import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { LegalPage } from './pages/LegalPage';
// ScrollToAnchor component to handle hash links when navigating between pages
function ScrollToAnchor() {
  const {
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        const element = document.getElementById(hash.replace('#', ''));
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }, 100);
    }
  }, [hash]);
  return null;
}
function AppLayout({
  isDark,
  toggleTheme
}: {
  isDark: boolean;
  toggleTheme: () => void;
}) {
  return <div className="min-h-screen bg-[#f8f9fb] dark:bg-[#0f1629] text-slate-800 dark:text-slate-300 font-sans selection:bg-primary-500/30 transition-colors duration-300" data-id="element-0">
      <Navbar isDark={isDark} toggleTheme={toggleTheme} data-id="element-1" />
      <Routes data-id="element-2">
        <Route path="/" element={<HomePage isDark={isDark} data-id="element-4" />} data-id="element-3" />
        <Route path="/legal" element={<LegalPage data-id="element-6" />} data-id="element-5" />
      </Routes>
      <Footer isDark={isDark} data-id="element-7" />
    </div>;
}
export function App() {
  const [isDark, setIsDark] = useState(() => {
    const saved = localStorage.getItem('sf-theme');
    return saved === 'dark';
  });
  useEffect(() => {
    localStorage.setItem('sf-theme', isDark ? 'dark' : 'light');
    if (isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [isDark]);
  const toggleTheme = () => setIsDark(prev => !prev);
  return <Router data-id="element-8">
      <ScrollToAnchor data-id="element-9" />
      <div className={`${isDark ? 'dark' : ''}`} data-id="element-10">
        <AppLayout isDark={isDark} toggleTheme={toggleTheme} data-id="element-11" />
      </div>
    </Router>;
}